import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function TagIcon({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75 2.88889C2.75 2.81244 2.81244 2.75 2.88889 2.75H7.264C7.53597 2.75 7.79772 2.85838 7.99056 3.05122L13.1017 8.16233C13.503 8.56366 13.503 9.21412 13.1017 9.61545L9.61545 13.1017C9.21412 13.503 8.56366 13.503 8.16233 13.1017L3.05122 7.99056C2.85838 7.79772 2.75 7.53597 2.75 7.264V2.88889ZM2.88889 1.25C1.98401 1.25 1.25 1.98401 1.25 2.88889V7.264C1.25 7.93425 1.51673 8.57739 1.99056 9.05122L7.10167 14.1623C8.08879 15.1494 9.68899 15.1494 10.6761 14.1623L14.1623 10.6761C15.1494 9.68899 15.1494 8.08879 14.1623 7.10167L9.05122 1.99056C8.57739 1.51673 7.93425 1.25 7.264 1.25H2.88889ZM6.66668 5.55545C6.66668 6.1691 6.16922 6.66656 5.55557 6.66656C4.94192 6.66656 4.44446 6.1691 4.44446 5.55545C4.44446 4.9418 4.94192 4.44434 5.55557 4.44434C6.16922 4.44434 6.66668 4.9418 6.66668 5.55545Z"
        fill="currentColor"
      />
    </svg>
  )
}
